import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'


export interface PayloadCalendarioSemanaMesByDate {
  date: string
}

export interface PayloadCalendarioSemanaMesById {
  id: number
}

export const calendarioSemanaMesServiceByDate = async (
  payload: PayloadCalendarioSemanaMesByDate
): Promise<ResponseAPI> => {
  const response = await api.get(
    `calendariosemanames/${payload.date}`
  );

  return response.data;
};

export const calendarioSemanaMesServiceById = async (
  payload: PayloadCalendarioSemanaMesById
): Promise<ResponseAPI> => {
  const response = await api.get(
    `calendariosemanames/id/${payload.id}`
  );

  return response.data;
};






